import React from "react";
import Blogs from "./components/Blogs";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import SearchField from "./components/SearchField";

function App() {
  return (
    <div>
      <Navbar />
      <SearchField />
      <Blogs />
      <Footer />
    </div>
  );
}

export default App;
